export default {
  path: '/valueManage',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/devOpsManage/home',
  children: [
    {
      // 首页
      path: 'index',
      name: 'valueManage',
      component: () => import('./index')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/pages/valueManage/router.js